import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { notify } from 'libs/common';
import { Button, themes, Popup2, Confirm } from 'libs/ui';
import { CustomSelect } from 'libs/form/lib/inputs/CustomSelect';
import { setBoardZone } from 'services/adv-service';
import { zones } from 'services/zones';
import { Content, Body, Left, Label, Modes, Mode, Radio, Error, Right, Screen, Places, Adv, Buttons } from './setup-board.styled';

const ADV_ONLY = 'adv_only';
const WITH_PLACES = 'adv_with_places';

/**
 * board (screen) settings: display mode and zone for free places
 * @param {*} props type - list_id, settings - board_settings, hasFiles, onSaved
 */
export const SetupBoard = ({ type, settings, hasFiles, onSaved }) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [mode, setMode] = useState(ADV_ONLY);
  const [zone, setZone] = useState('');
  const [error, setError] = useState('');

  const savedMode = settings?.display_mode || ADV_ONLY;

  const showForm = () => {
    setMode(savedMode);
    setZone(settings?.zone_id || '');
    setError('');
    setShow(true);
  };

  const hideForm = () => {
    setShow(false);
    setConfirm(false);
  };

  const withPlaces = mode === WITH_PLACES;

  const save = async () => {
    setConfirm(false);
    setSaving(true);
    let err = false;
    await setBoardZone(type, withPlaces ? zone : null).catch((e) => {
      err = true;
      setError(e?.message ? e.message : String(e));
    });
    setSaving(false);
    if (!err) {
      hideForm();
      notify(t('messages.ВНИМАНИЕ!'), t('messages.Сохранено успешно'), 'success');
      onSaved();
    }
  };

  const trySave = () => {
    if (withPlaces && !zone) {
      setError(t('adv.board_zone_required'));
      return;
    }
    setError('');
    if (hasFiles && mode !== savedMode) {
      setConfirm(true);
    } else {
      save();
    }
  };

  const changeMode = (val) => {
    setMode(val);
    setError('');
  };

  const zoneItems = zones.getZones();
  const zoneInput = {
    value: zone,
    onChange: (v) => {
      setZone(v);
      setError('');
    },
  };

  const modes = [
    { value: ADV_ONLY, name: t('adv.board_only_adv') },
    { value: WITH_PLACES, name: t('adv.board_adv_places') },
  ];

  const confirmProps = {
    title: t('adv.board_change_title'),
    info: t('adv.board_change_info'),
    type: 'warning',
    width: '440px',
    align: 'right',
    cancelButton: { text: t('buttons.Ок'), func: () => setConfirm(false) },
    // acceptButton: { text: t('buttons.Сохранить'), func: save, theme: themes.green },
  };

  return (
    <Content>
      <Button theme={themes.blue} onClick={showForm}>{t('adv.board_settings')}</Button>
      {show && (
        <Popup2 close={hideForm} title={t('adv.board_settings')} w={680}>
          <Body>
            <Left>
              <Label>{t('adv.board_type')}</Label>
              <Modes>
                {modes.map((el) => (
                  <Mode key={el.value} $active={mode === el.value} onClick={() => changeMode(el.value)}>
                    <Radio $active={mode === el.value} />
                    {el.name}
                  </Mode>
                ))}
              </Modes>
              {withPlaces && (
                <>
                  <Label className="zone">{t('adv.board_zone')}</Label>
                  <CustomSelect input={zoneInput}>
                    <option value="">{t('adv.board_choose_zone')}</option>
                    {zoneItems.map((el) => (
                      <option key={el.zone_id} value={el.zone_id}>
                        {el.name}
                      </option>
                    ))}
                  </CustomSelect>
                </>
              )}
              {error && <Error>{error}</Error>}
            </Left>
            <Right>
              {t('adv.board_preview')}
              <Screen>
                {withPlaces && <Places>{zone ? `${zone} 999` : '999'}</Places>}
                <Adv>{t('adv.board_adv')}</Adv>
              </Screen>
              {withPlaces ? t('adv.board_ratio_places') : t('adv.board_ratio_adv')}
            </Right>
          </Body>
          <Buttons>
            <Button type="button" onClick={hideForm}>
              {t('buttons.Отменить')}
            </Button>
            <Button type="button" theme={themes.green} onClick={trySave} disabled={saving}>
              {t('buttons.Сохранить')}
            </Button>
          </Buttons>
        </Popup2>
      )}
      {confirm && <Confirm {...confirmProps} />}
    </Content>
  );
};

export default SetupBoard;
